import React, {useEffect, useState} from "react";
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { compose, withHandlers, withPropsOnChange } from "recompose";
import { LocalForm, actions } from "react-redux-form";
import {
  Page,
  onMount,
  FormGroup,
} from "components/common";
import { withDefaultReportParams } from "../Xero/Reports/hooks/useDefaultReportParams";
import { formatDate } from "../../services/util";
import { range } from "lodash";
import moment from "moment";
import MainCard from "./MainCard";
import { Trans, useTranslation } from "react-i18next";

const ChartPage = (data) => {
  
  const { t } = useTranslation()

  const item = data.data

  const getRandomColors = (count) => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(
        Math.random() * 256
      )}, 0.6)`;
      colors.push(color);
    }
    return colors;
  };

  const section = item.Rows.filter(row => row.RowType === 'Section');
  const sectionLength = section.length;
  
  const summaryRow = section.map(sectionItem => sectionItem.Rows.find(row => row.RowType === 'SummaryRow')).filter(row => row !== undefined);

  const getValueFromSummaryRow = (summaryRow, targetValue) => {
    const targetRow = summaryRow.find(
      (row) => row !== undefined && row.Cells[0]?.Value === targetValue
    );
  
    console.log(`${targetValue} Row:`, targetRow);
  
    const tName = targetRow ? targetRow.Cells[0]?.Value : undefined;
    const tValue = targetRow ? targetRow.Cells[1]?.Value : undefined;
  
    return { tName, tValue };
  };
  
  const totalAssetsValues = getValueFromSummaryRow(summaryRow, 'Total Assets');
  const totalLiabilitiesValues = getValueFromSummaryRow(summaryRow, 'Total Liabilities');
  const totalEquityValues = getValueFromSummaryRow(summaryRow, 'Total Equity');
  
  const undef = undefined

  const filterData = (values) => values.filter(value => value !== undefined);

    const chartLabels = filterData([t(totalAssetsValues.tName), t(totalEquityValues.tName), t(totalLiabilitiesValues.tName)]);
    const chartData = filterData([totalAssetsValues.tValue, totalEquityValues.tValue, totalLiabilitiesValues.tValue]);


  const barChartData = {
    labels: chartLabels,
    datasets: [
      {
        label: t(item.ReportTitles[1]),
        data: chartData,
        backgroundColor: ['rgba(75, 192, 192, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 99, 132, 0.2)', ],
        borderColor: ['rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)',],
        borderWidth: 1,
        
      },
    ],
  };

  const yearWord = item.ReportTitles[2].split(' ').pop();
  console.log(yearWord);

  return (
    <Page>
      <MainCard linkTo="/reports/balance_sheet">
            <div className='my-4' style={{ flex: '1 1 400px' }}>
            <h4><Trans>Overview Balance of</Trans> {item.ReportTitles[1]}</h4>
            <p><strong><Trans>For the Year of</Trans> {yearWord}{/*item.ReportTitles[2]*/}</strong></p>
            <Bar data={barChartData} options={{ maintainAspectRatio: true, responsive: true }} />
          </div>
      </MainCard>
    </Page>
  );
};


const loadReport = (item, xero) =>
  xero.get("reports/BalanceSheet", {
    params: {
      extra_params: item,
    },
  }).get("data");

export const enhance = compose(
  withDefaultReportParams(() => ({
    date: formatDate(moment().endOf("month")),
    periods: 1,
    timeframe: "YEAR",
  })),
  onMount(({ xero, item }) => () => {
    return Promise.props({
      data: loadReport(item, xero),
      item,
    });
  }),
  withPropsOnChange(["t"], ({ t }) => ({
    periods: range(1, 11 + 1).map((i) => ({ label: i, value: i })),
    timeframes: [
      ["MONTH", t("Month")],
      ["QUARTER", t("Quarter")],
      ["YEAR", t("Year")],
    ].map(([value, label]) => ({ label, value })),
  })),
);

export default enhance(ChartPage);